import React from "react";
import { UserForm } from "../shared/userForm";

function CreateUserPage() {
  return <UserForm />;
}

export default CreateUserPage;
